import useCreate from "@/hooks/use-create";
import { UseLoadingReturn } from "@/hooks/use-loading";
import { IMessage, IMessageInput } from "@/interfaces/message.interface";
import messageService from "@/services/message.service";
import { RequestsProps } from "@/types/requests.types";

export type CreateMessageProps = {
  formData: IMessageInput;
} & RequestsProps;

export type UseCreateMessageReturn = {
  create: (props: CreateMessageProps) => Promise<IMessage>;
} & UseLoadingReturn;

const useCreateMessage = (): UseCreateMessageReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, create } = useCreate<IMessageInput>({
    operation: (formData) => messageService.create(formData),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    create,
  };
};

export default useCreateMessage;
